import { API, CustomAxiosConfig } from './types'
import { paginatedTransform } from 'src/services/skuit/utils'
import { Cart, PaginatedResponse } from 'src/api/models'

export class CartAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Cart>> => {
    const response = await this.api.get('/carts', config)
    response.data = paginatedTransform(Cart)(response.data)
    return response.data
  }

  sync = async (guid: string, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.post(`/carts/${guid}/sync`, {}, config)
    return null
  }
}
